/**
 * Bir ürünün Kaspersky olup olmadığının tek kaynak kuralı.
 *
 * Backend karşılığı: Index.Group.Services/Basket/BasketService.cs -> KasperskyBasketControl
 * (`TableProducts.CompanyId == 2 && TableProducts.QuotaNo == "145"`). İkisi birlikte
 * değiştirilmelidir.
 *
 * MARKA STRING'İ KULLANILMAZ: `Product.Brand` alanı farklı yazımlarla geliyor
 * (ör. HomePageHeader marka adını 'KASPERSKY' olarak karşılaştırıyor), bu yüzden tam
 * eşitlik kontrolü sessizce hep false döner. Ayırt edici daima şirket + kota numarasıdır.
 *
 * Kural iki yerde kullanılıyor:
 *  - Reseller alanının zorunluluğu (bkz. resellerRule.ts),
 *  - Sepet ödeme ekranında İyzico'nun kapatılması (bkz. pages/MyCard/index.tsx).
 */

/** Kaspersky ürünlerinin kota numarası. */
export const KASPERSKY_QUOTA_NO = '145'

/** Kaspersky ürünlerinin bağlı olduğu şirket (Netex) kaydının Id'si. SAP kodu değildir. */
export const KASPERSKY_COMPANY_ID = 2

/** Kullanıcıya gösterilen marka etiketi. Kural kontrolünde kullanılmaz, yalnız metinlerde. */
export const KASPERSKY_BRAND_LABEL = 'Kaspersky'

/**
 * Ürün Kaspersky mi?
 * Kota ya da şirket bilgisi hiç gelmezse false döner — eksik veri yüzünden sipariş bloklanmaz.
 */
export const isKasperskyProduct = (
  quotaNo: string | undefined | null,
  companyId: number | undefined | null
): boolean =>
  companyId !== undefined &&
  companyId !== null &&
  Number(companyId) === KASPERSKY_COMPANY_ID &&
  (quotaNo ?? '').trim() === KASPERSKY_QUOTA_NO
